export default {
  countryCode: 'PH',
  regionLinks: [
    {
      title: 'Manila',
    },
    {
      title: 'Cebu',
    },
    {
      title: 'Davao',
    },
  ],
};
